import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/messaging';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from '@/App.vue';
import router from '@/router.ts';
import { store, storeEventBus } from '@/store.ts';
import * as ExchangeFuncs from '@/util-funcs/exchange-object-funcs';
import messages from '@/translations.ts';
import storage from 'local-storage-fallback'; // if you use es6 or typescript.
import tm_Bill from '@/components/other/tm-bill.vue';
import tm_Modal from '@/components/other/tm-modal.vue';
import tm_Slider from '@/components/other/tm-slider.vue';
import tm_StripePayment from '@/components/other/tm-stripe-payment.vue';
import tm_Review from '@/components/other/tm-review.vue';
import tm_Checkbox from '@/components/other/tm-checkbox.vue';
import tm_Notifier from '@/components/other/tm-notifier.vue';
import tm_Carousel from '@/components/other/tm-carousel.vue';
import tm_UserForm from '@/components/other/tm-user-form.vue';
import tm_Accordion from '@/components/other/tm-accordion.vue';
import tm_OrderItem from '@/components/other/tm-order-item.vue';
import tm_PageHeader from '@/components/other/tm-page-header.vue';
import tm_OrderTypePicker from '@/components/other/tm-order-type-picker.vue';
import tm_LanguageSelect from '@/components/other/tm-language-select.vue';
import tm_CookiePolicy from '@/components/pages/tm-cookie-policy-page.vue';
import tm_PrivacyPolicy from '@/components/pages/tm-privacy-policy-page.vue';
import tm_TermsOfService from '@/components/pages/tm-terms-of-service-page.vue';
import tm_OrderTimePicker from '@/components/other/tm-order-time-picker.vue';
import tm_LocationHoursModal from '@/components/other/tm-location-hours-modal.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import { parse as dateFnsParse, format as dateFnsFormat } from 'date-fns';
import {
  faTimes,
  faBook,
  faComment,
  faComments,
  faPaperPlane,
  faBars,
  faInfoCircle,
  faCheck,
  faMinus,
  faPlus,
  faAngleRight,
  faAngleDown,
  faImages,
  faBackspace,
  faHandshake,
  faCog,
  faMobile,
  faSearch,
  faEraser,
  faHandPaper,
  faTheaterMasks,
  faQuestionCircle,
  faSlidersH,
  faMapMarkerAlt,
  faListOl,
  faConciergeBell,
  faTint,
  faSquare,
  faThumbsUp,
  faReply,
  faHandPointUp,
  faFile,
  faFileArchive,
  faCopy,
  faBalanceScale,
  faUserShield,
  faThumbsDown,
  faCookie,
  faWifi,
  faRedo,
  faCreditCard,
  faSignIn,
  faSignOut,
  faUser,
  faStar,
  faSparkles,
  faArrowRight,
  faMapMarker,
  faBooks,
  faClock,
  faArrowLeft,
  faCar,
  faShoppingBag,
  faChair,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faHeart,
  faLeaf,
  faFire,
  faCocktail,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faTimes,
  faBook,
  faComment,
  faComments,
  faPaperPlane,
  faBars,
  faInfoCircle,
  faCheck,
  faMinus,
  faPlus,
  faAngleRight,
  faAngleDown,
  faImages,
  faBackspace,
  faHandshake,
  faCog,
  faMobile,
  faSearch,
  faEraser,
  faHandPaper,
  faTheaterMasks,
  faQuestionCircle,
  faSlidersH,
  faMapMarkerAlt,
  faListOl,
  faConciergeBell,
  faTint,
  faSquare,
  faThumbsUp,
  faReply,
  faHandPointUp,
  faFile,
  faFileArchive,
  faCopy,
  faBalanceScale,
  faUserShield,
  faThumbsDown,
  faHeart,
  faLeaf,
  faFire,
  faCocktail,
  faCookie,
  faWifi,
  faRedo,
  faCreditCard,
  faSignIn,
  faSignOut,
  faUser,
  faStar,
  faSparkles,
  faArrowRight,
  faMapMarker,
  faCreditCard,
  faBooks,
  faClock,
  faArrowLeft,
  faCar,
  faShoppingBag,
  faChair,
);

Vue.config.productionTip = false;

Vue.use(VueI18n);

Vue.component('fa', FontAwesomeIcon);
Vue.component('tm-bill', tm_Bill);
Vue.component('tm-modal', tm_Modal);
Vue.component('tm-slider', tm_Slider);
Vue.component('tm-review', tm_Review);
Vue.component('tm-checkbox', tm_Checkbox);
Vue.component('tm-notifier', tm_Notifier);
Vue.component('tm-carousel', tm_Carousel);
Vue.component('tm-user-form', tm_UserForm);
Vue.component('tm-accordion', tm_Accordion);
Vue.component('tm-order-item', tm_OrderItem);
Vue.component('tm-page-header', tm_PageHeader);
Vue.component('tm-stripe-payment', tm_StripePayment);
Vue.component('tm-language-select', tm_LanguageSelect);
Vue.component('tm-cookie-policy', tm_CookiePolicy);
Vue.component('tm-privacy-policy', tm_PrivacyPolicy);
Vue.component('tm-terms-of-service', tm_TermsOfService);
Vue.component('tm-order-type-picker', tm_OrderTypePicker);
Vue.component('tm-order-time-picker', tm_OrderTimePicker);
Vue.component('tm-location-hours-modal', tm_LocationHoursModal);

let stillLoading = false;
let deferredPrompt: any;
const i18n = new VueI18n({
  locale: 'en',
  messages,
});
let afterSignInCallBack = (): void => undefined;

export const callAfterSignInCallBack = () => {
  afterSignInCallBack();
  afterSignInCallBack = (): void => undefined;
};
export let t: any = messages.en;
export const masterReferenceDictionary: any = {};
export const masterResourceDictionary: any = {};
export const masterTranslationDictionary: any = {
  de: null,
  es: null,
  fr: null,
  zh: null,
  en: null,
};
export const eventBus = storeEventBus;
export let rootComponent: any = null;

window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = e;
});

export const isProductionEnv = () => {
  const locationId = store.state.locationId;
  if (locationId !== -1) {
    const locationCode = locationId.toString(36).toUpperCase();
    // Demo menus should also be in staging mode. The test locations should still be live to test lives payments though.
    if (Constants.DEMO_LOCATION_CODES.includes(locationCode)) {
      return false;
    }
  }
  return process.env.NODE_ENV === 'production' && window.location.hostname.includes('tapmenu.app');
};

let firebaseApp: firebase.app.App;
if (isProductionEnv()) {
  firebaseApp = firebase.initializeApp({
    apiKey: 'AIzaSyAprGzyhgKQGBfAqOHwvZYV-SHi7WnJHLM',
    authDomain: 'table-tap.firebaseapp.com',
    databaseURL: 'https://table-tap.firebaseio.com',
    projectId: 'table-tap',
    storageBucket: 'gs://table-tap.appspot.com',
    messagingSenderId: '968167397316',
    appId: '1:968167397316:android:98c2e31c5d0adc37f8b691',
  });
} else {
  firebaseApp = firebase.initializeApp({
    apiKey: 'AIzaSyBBdLl98Po1w3DWVCUBlIN1PMa_irUPTJc',
    authDomain: 'table-tap-test.firebaseapp.com',
    databaseURL: 'https://table-tap-test.firebaseio.com',
    projectId: 'table-tap-test',
    storageBucket: 'table-tap-test.appspot.com',
    messagingSenderId: '689783001272',
    appId: '1:689783001272:web:f726702737498fedbae44d',
    measurementId: 'G-6J7SBTB9CE',
  });
}

export const currFirestore = firebaseApp.firestore();

export const initApp = async () => {

  await changeLanguage();

  rootComponent = new Vue({
    el: '#app',
    store,
    router,
    i18n,
    render: (h) => h(App),
  }).$children[0];
};

export const onShowPWAPrompt = () => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    deferredPrompt.userChoice.then(() => {
      deferredPrompt = null;
    });
  }
};

export const getStripePublicKey = (): string => {
  if (isProductionEnv()) {
    return 'pk_live_ZGY3l1wMaT1TtD1vdKhH8qcw004Cv7Zp1l';
  }
  return 'pk_test_aHrOPUMP6w2kx5zBE8p30lgG00kFaQDpuB';
};

export const changeLanguage = async () => {

  const localeCode = store.state.locale;

  if (!localeCode) {
    return;
  }

  const setLocale = () => {
    localStoreSetSimple('locale', localeCode);
    i18n.locale = localeCode;
    t = (messages as any)[localeCode];
  };


  const alreadyFetchedLanguage = Boolean(Object.keys(i18n.messages[localeCode]).length);
  if (!alreadyFetchedLanguage) {
    showLoading();
    currFirestore.collection('menuTranslations').doc(localeCode).get().then((docSnap) => {
      if (docSnap.exists) {
        const translationsObject: any = {
          ...messages.en, // Merge to fill in any missing translations.
          ...docSnap.data(),
        };
        i18n.setLocaleMessage(localeCode, translationsObject);
        setLocale();
      } else {
        showError('No data in the database for that language.');
      }
    }).catch((err) => {
      showError('Fetching translations unsuccessful. ' + err);
    }).finally(() => {
      hideLoading();
    });
  } else {
    setLocale();
  }
};

export const getMenuTranslations = () => {
  const locale = store.state.locale;
  // Only get translations if a locale has been chosen that isn't english and we haven't already gotten them before.
  if (locale && locale !== 'en' && !masterTranslationDictionary[locale]) {
    store.state.currentSubscriptionDoc.collection('translations').doc(locale).get().then((docSnap) => {
      if (docSnap.exists) {
        masterTranslationDictionary[locale] = docSnap.data();
        eventBus.$emit('menuTranslationUpdated');
      }
    });
  }
};

export const getTranslatedField = (item: MenuItem | MenuCategory, field: string): string => {
  const locale = store.state.locale;
  if (locale && locale !== 'en') {
    const translations = masterTranslationDictionary[locale];
    if (translations) {
      return translations[item.docId]?.[field] || '';
    }
  }
  return (item as any)[field] || '';
};

export const logout = () => {
  store.commit('setIsLoggedIn', false);
  store.commit('setUserId', '');
};

export const switchToTakeout = () => {
  const newStationCode = store.state.locationId.toString(36).toUpperCase() + Constants.GENERAL_TAKEOUT_CODE;
  rootComponent.initializeEstablishmentData(newStationCode);
  routerPush({ path: Constants.allRoutes.menu });
};

export const switchToDelivery = () => {
  const newStationCode = store.state.locationId.toString(36).toUpperCase() + Constants.GENERAL_DELIVERY_CODE;
  rootComponent.initializeEstablishmentData(newStationCode);
  routerPush({ path: Constants.allRoutes.menu });
};

export const switchToViewOnly = () => {
  const newStationCode = store.state.locationId.toString(36).toUpperCase() + Constants.VIEW_ONLY_STATION_CODE;
  rootComponent.initializeEstablishmentData(newStationCode);
  routerPush({ path: Constants.allRoutes.menu });
};

export const userEstablishmentExchangeObjectExists = (): boolean => {
  return store.state.currentUserEstablishmentExchangeObject.stationId !== Constants.UNINITIALIZED_EXCHANGE_OBJ_STATION_NUMBER;
};

export const signOut = () => {
  showLoading();
  firebase
    .auth()
    .signOut()
    .then(() => {
      window.location.reload(true);
    })
    .catch((error: any) => {
      showError('Could not sign out. ' + error?.message);
    })
    .finally(() => {
      hideLoading();
    });
};

export const updateCurrentClientUser = async (data: any) => { // Make sure that a malicious update cannot change permissions

  showLoading();
  data.dateUpdated = firebase.firestore.FieldValue.serverTimestamp();
  return currFirestore.collection('clientUsers').doc(store.state.userId).update(data).then(() => {
    showSuccess(t.infoUpdatedSuccessfully);
    store.commit('setCurrentClientUser', {
      ...store.state.currentClientUser,
      ...data,
    });
  }).catch((error: any) => {
    showError('There was a problem updating your account. ' + (error?.message));
  }).finally(() => {
    hideLoading();
  });
};

export const setUpForSignedInAuthUser = async (user: firebase.User, clientUserData: ClientUser | null = null) => {

  if (rootComponent.isTestingMode) {
    return;
  }

  showLoading();

  store.commit('setUserId', user.uid);
  store.commit('setIsLoggedIn', true);

  // if (!user.isAnonymous) { // Anonymous users don't have database data stored about them.
  const clientUserDoc = currFirestore.collection('clientUsers').doc(user.uid);
  clientUserDoc.get().then((clientUserDocSnap: firebase.firestore.DocumentSnapshot) => {
    store.commit('setCurrentClientUserDoc', clientUserDoc);
    if (clientUserDocSnap.exists) { // If we have a record for this user, fetch and store it locally.
      const clientUser: ClientUser = clientUserDocSnap.data() as ClientUser;
      store.commit('setCurrentClientUser', clientUser);
    } else { // If we do not have a record this client user than make a new one.
      const newClientUser: ClientUser = {
        ...Constants.EMPTY_CLIENT_USER,
        displayName: user.displayName || store.state.referenceName,
        photoURL: user.photoURL || '',
        email: user.email || '',
        settings: {
          ...Constants.EMPTY_CLIENT_USER.settings,
          contactEmail: user.email || '',
          referenceName: user.displayName || store.state.referenceName || '',
          includeTaxWithPrices: store.state.includeTaxWithPrices,
          showImagesAutomatically: store.state.showImagesAutomatically,
        },
      };
      clientUserDoc.set(newClientUser).catch((error: any) => {
        showError('Could not save the new user data to the database. ' + error?.message);
        hideLoading();
      });
      store.commit('setCurrentClientUser', newClientUser);
    }
    store.commit('setInitializationComplete', true);
  });
  // } else {
  //   store.commit('setInitializationComplete', true);
  // }

  const locationDoc = store.state.currentLocationDoc;
  const userEstablishmentExchangeDoc: firebase.firestore.DocumentReference = locationDoc.collection('userLocationExchangeCollection').doc(user.uid);

  userEstablishmentExchangeDoc.get().then((exhangeObjectDocSnap: firebase.firestore.DocumentSnapshot) => {

    // Check if an exchange object already exists for this user/establishment pairing.
    if (exhangeObjectDocSnap.exists) {

      const currEstablishmentExchangeObject: UserEstablishmentExchangeObject = exhangeObjectDocSnap.data() as UserEstablishmentExchangeObject;

      // If the exchange object we're about to start watching has been idle for 5 hours. Delete it, create a fresh one, and notifiy the establishment.
      // This mitigates the problem of staff forgetting to close out stations and there is a similar function to this on the manager side.
      const seconds = currEstablishmentExchangeObject.dateUpdated && (currEstablishmentExchangeObject.dateUpdated as any).seconds;

      if (seconds && ((Date.now() / 1000 - seconds) > Constants.EXCHANGE_OBJECT_EXPIRY_TIME_IN_SECONDS)) {
        userEstablishmentExchangeDoc.delete().catch((error: any) => {
          showError('Could not delete outdated user establishment exchange doc. ' + (error?.message));
        });
      } else {
        // If exchange document already exists and isn't expired then set up watchers and notifications.
        store.commit('setCurrentUserEstablishmentExchangeDoc', userEstablishmentExchangeDoc);
        ExchangeFuncs.onExchangeDocReady();
      }
    } else {
      /*
        If store.state.currentUserEstablishmentExchangeObject's station is not UNINITIALIZED_EXCHANGE_OBJ_STATION_NUMBER at this point then we're upgrading an anonymous user to a full user.
        This is because we only create set the stationId of the object to something other than UNINITIALIZED_EXCHANGE_OBJ_STATION_NUMBER after a user has logged in.
        So if the stationId is not UNINITIALIZED_EXCHANGE_OBJ_STATION_NUMBER when logging in, then we were already logged in and we're just upgrading the account.
      */
      if (userEstablishmentExchangeObjectExists()) {
        // Create a new exchange doc for the new user that contains the data of the old exchange object doc. We need to do this in case the userId changed due to a anonymous-upgrade-merge-conflict.
        ExchangeFuncs.updateExchangeObject({ ...store.state.currentUserEstablishmentExchangeObject });
      } else { // In this case a brand new user is making a brand new order for the first time.
        // When this happens a location check will run, which will prompt for the users location, then whether or not that succeeds, sendNotification will call updateExchangeObject, which will create the exchange object for the new user if need be.
        callAfterSignInCallBack();
      }
    }

    hideLoading();
  }).catch((error: any) => {
    nonDebugLog('Could not get user establishment exchange doc. ' + error?.message);
    hideLoading();
  });
};

export const updateOrderTypeAvailabilities = (): Promise<any> => {
  return new Promise((resolve: any, reject: any) => {
    getResourceArrayFromDb('timeSlot').then(() => {
      recursivelyConvertAllDocRefsToDataInResourceArray('timeSlot');
      store.state.currentLocationDoc?.get().then((documentSnapshot: firebase.firestore.DocumentSnapshot) => {
        const locationData: EstablishmentLocation = documentSnapshot.data() as EstablishmentLocation;
        store.commit('setTablesideAvailable', locationData.isTablesideOn && isRightTime(locationData.tablesideTimeSlots, locationData.utcOffset));
        store.commit('setTakeoutAvailable', locationData.isTakeoutOn && isRightTime(locationData.takeoutTimeSlots, locationData.utcOffset));
        store.commit('setDeliveryAvailable', locationData.isDeliveryOn && isRightTime(locationData.deliveryTimeSlots, locationData.utcOffset));
        resolve();
      }).catch(() => {
        reject('Could not get updated lcoation');
      });
    }).catch(() => {
      reject('Could not get updated timeslots');
    });
  });
};

export const getResourceArrayFromDb = (resourceName: string) => {
  showLoading();
  return store.state.currentSubscriptionDoc.collection(resourceName + 'Collection').get().then((querySnapshot) => {
    store.commit(`set${capitalizeFirstLetter(resourceName)}Array`, querySnapshotToResourceArray(querySnapshot));
  }).catch((error: any) => {
    showError('Could not retreive ' + resourceName + ' list. Subscription may be inactive.' + error?.message);
  }).finally(() => {
    hideLoading();
  });
};

export const querySnapshotToResourceArray = (querySnapshot: any) => {
  const arr: any[] = [];
  querySnapshot.forEach((doc: firebase.firestore.DocumentSnapshot) => {
    const docObj = doc.data();
    masterReferenceDictionary[doc.id] = doc.ref;
    masterResourceDictionary[doc.id] = docObj;
    arr.push(docObj);
  });
  return arr;
};

export const mapDocRefArraytoResourceArray = (docRefArray: any[]): any[] => {

  if (Array.isArray(docRefArray)) {
    return docRefArray.map((docRef: any) => {
      return { ...masterResourceDictionary[docRef.id] }; // Shallow copy object so that form clears don't mess with this data.
    });
  }
  return [];
};

export const mapDocRefToResource = (docRef: any): firebase.firestore.DocumentReference => {
  return docRef ? { ...masterResourceDictionary[docRef.id] } : null;
};

function recursivelyConvertAllDocRefsToDataHelper(obj: any) {
  if (!obj) { return; }
  Object.keys(obj).forEach((prop) => {
    const curr = obj[prop];
    if (Array.isArray(curr) && curr.length && curr[0].hasOwnProperty('firestore')) { // If current resource has document references.
      obj[prop] = mapDocRefArraytoResourceArray(curr);
    } else if (!Array.isArray(curr) && curr && curr.hasOwnProperty('firestore')) {
      obj[prop] = mapDocRefToResource(curr);
    }
    if (typeof obj[prop] === 'object') {
      recursivelyConvertAllDocRefsToDataHelper(obj[prop]);
    }
  });
}

export const recursivelyConvertAllDocRefsToDataInResourceArray = (resourceName: string) => {

  const resourceArray = (store.state as any)[resourceName + 'Array'];
  resourceArray.forEach((obj: any) => {
    recursivelyConvertAllDocRefsToDataHelper(obj);
  });
  store.commit('set' + capitalizeFirstLetter(resourceName) + 'Array', resourceArray);
};

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const toTitleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const camelToTitleCase = (str: string) => {
  const result = str.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1); // capitalize the first letter - as an example.
};

export const getParameterByName = (n: string): string => {

  const url: string = window.location.href;
  const name = n.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  const results = regex.exec(url);
  if (!results) { return ''; }
  if (!results[2]) { return ''; }
  return decodeURIComponent(results[2].replace(/\+/g, ' ')) || '';
};

export const isFeatureEnabled = (flag: Enums.eFeatureFlagTypes): boolean => {
  const locationIdBase36 = store.state.locationId.toString(36).toUpperCase();
  switch (flag) {
    case Enums.eFeatureFlagTypes.prod:
      return true;
    case Enums.eFeatureFlagTypes.test:
      return Constants.TEST_LOCATION_CODES.includes(locationIdBase36);
    case Enums.eFeatureFlagTypes.demo:
      return Constants.DEMO_LOCATION_CODES.includes(locationIdBase36);
    case Enums.eFeatureFlagTypes.off:
      return false;
  }
  return false;
};

export const showConfirmation = (title: string, msg: string, onConfirmFunc = (): void => undefined, onCancelFunc = (): void => undefined) => {
  Vue.nextTick(() => { // Added a next tick for instances where modals are instantly closed on route changes.
    rootComponent.showConfirmationModalFunc(title, msg, onConfirmFunc, onCancelFunc);
  });
};

export const showGlobalModal = (title: string, msg: string) => {
  Vue.nextTick(() => { // Added a next tick for instances where modals are instantly closed on route changes.
    rootComponent.showGlobalModalFunc(title, msg);
  });
};

export const doTutorialStep = (tutorialStepToDo: number) => {

  const currTutorialsStep = Number(localStoreGetSimple('tutorialStep'));

  // Don't repeat steps if the user has already encountered it.
  if (currTutorialsStep !== tutorialStepToDo) {
    return;
  }

  switch (tutorialStepToDo) {
    case 1:
      showGlobalModal(t.menuPageTutorialTitle, t.menuPageTutorialMsg);
      break;
  }
  localStoreSetSimple('tutorialStep', String(currTutorialsStep + 1));
};

export const mobileCheck = () => {
  let check = false;
  const typedWindow: any = window;
  ((a) => {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        a.substr(0, 4)
      )
    ) {
      check = true;
    }
  })(navigator.userAgent || navigator.vendor || typedWindow.opera);
  return check;
};

export const showError = (str: string) => {
  console.error(str);
  if (!rootComponent || !rootComponent.isMounted || !str) { return; }
  rootComponent.showSnackBarFunc(str, Enums.eSnackBarTypes.error);
};

export const showNotice = (str: string) => {
  if (!rootComponent || !rootComponent.isMounted || !str) { return; }
  rootComponent.showSnackBarFunc(str, Enums.eSnackBarTypes.notice);
};

export const showSuccess = (str: string) => {
  if (!rootComponent || !rootComponent.isMounted || !str) { return; }
  rootComponent.showSnackBarFunc(str, Enums.eSnackBarTypes.success);
};

export const showWarning = (str: string) => {
  if (!rootComponent || !rootComponent.isMounted || !str) { return; }
  rootComponent.showSnackBarFunc(str, Enums.eSnackBarTypes.warning);
};

export const showLoading = () => {
  if (navigator.onLine) {
    stillLoading = true;
    setTimeout(() => {
      if (stillLoading) {
        rootComponent.isLoading = true;
      }
    }, 0);
  }
};

export const hideLoading = () => {
  stillLoading = false;
  rootComponent.opaqueLoadingBackground = false; // After first load, the loading spinner should not have an opaque background.
  setTimeout(() => {
    rootComponent.isLoading = false;
  }, 100); // Anti FOUC delay.
};

export const isRightTime = (timeSlots: Array<TimeSlot | firebase.firestore.DocumentReference>, utcOffset: number | null = null, epochDateInMs: number = Date.now()) => {

  // If no time slots in the array then we assume any time is fine.
  if (!timeSlots || !timeSlots.length) {
    return true;
  }

  const resourceOnlyTimeSlots: TimeSlot[] = timeSlots.map((timeSlot: TimeSlot | firebase.firestore.DocumentReference) => {
    if (!(timeSlot as TimeSlot).docId) {
      // If the timeslot does not have a docId then it is a document reference that we need to convert to a resource.
      return masterResourceDictionary[(timeSlot as firebase.firestore.DocumentReference).id];
    }
    return timeSlot;
  });

  return resourceOnlyTimeSlots.some((el: TimeSlot) => {

    if (!el) {
      return true;
    }

    if (!utcOffset) {
      utcOffset = store.state.currentLocation.utcOffset || 0;
    }

    const currDate = new Date(epochDateInMs);
    const timezoneOffsetForClient = -1 * (currDate.getTimezoneOffset() + currDate.dstOffsetForNorthernHemisphere());
    const timezoneOffsetDifferenceInMinutes = timezoneOffsetForClient - utcOffset;
    const minutesPassedToday = currDate.getMinutes() + currDate.getHours() * 60 - timezoneOffsetDifferenceInMinutes;

    // Use the locations local time as the date.
    currDate.setHours(Math.floor(minutesPassedToday / 60), minutesPassedToday % 60);

    let currDay = '';

    switch (currDate.getDay()) {
      case 0:
        currDay = Enums.eWeekdays.sunday;
        break;
      case 1:
        currDay = Enums.eWeekdays.monday;
        break;
      case 2:
        currDay = Enums.eWeekdays.tuesday;
        break;
      case 3:
        currDay = Enums.eWeekdays.wednesday;
        break;
      case 4:
        currDay = Enums.eWeekdays.thursday;
        break;
      case 5:
        currDay = Enums.eWeekdays.friday;
        break;
      case 6:
        currDay = Enums.eWeekdays.saturday;
        break;
    }

    // If days of week are specified in this timeslot but the current day of the week is not included in that collection then return false
    if (el.daysOfWeek && el.daysOfWeek.length && !el.daysOfWeek.includes(currDay)) {
      return false;
    }

    if (el.timeOfDayStart) {
      // If current time of day is before start of day time.
      if (minutesPassedToday < militaryToMinutes(el.timeOfDayStart)) {
        return false;
      }
    }

    if (el.timeOfDayEnd) {
      // If current time of day is after end of day time.
      if (minutesPassedToday > militaryToMinutes(el.timeOfDayEnd)) {
        return false;
      }
    }

    return true;
  });
};

export const orderAheadForPossibleForTimeslots = (timeSlots: Array<TimeSlot | firebase.firestore.DocumentReference>, utcOffset: number | null = null) => {

  // If no time slots in the array then we assume any time is fine.
  if (!timeSlots || !timeSlots.length) {
    return true;
  }

  const resourceOnlyTimeSlots: TimeSlot[] = timeSlots.map((timeSlot: TimeSlot | firebase.firestore.DocumentReference) => {
    if (!(timeSlot as TimeSlot).docId) {
      // If the timeslot does not have a docId then it is a document reference that we need to convert to a resource.
      return masterResourceDictionary[(timeSlot as firebase.firestore.DocumentReference).id];
    }
    return timeSlot;
  });

  return resourceOnlyTimeSlots.some((el: TimeSlot) => {

    if (!el) {
      return true;
    }

    if (!utcOffset) {
      utcOffset = store.state.currentLocation.utcOffset || 0;
    }

    const currDate = new Date();
    const timezoneOffsetForClient = -1 * currDate.getTimezoneOffset();
    const timezoneOffsetDifferenceInMinutes = timezoneOffsetForClient - utcOffset;
    const minutesPassedToday = currDate.getMinutes() + currDate.getHours() * 60 - timezoneOffsetDifferenceInMinutes;

    // Use the locations local time as the date.
    currDate.setHours(Math.floor(minutesPassedToday / 60), minutesPassedToday % 60);

    let currDay = '';
    let tomorrow = '';

    switch (currDate.getDay()) {
      case 0:
        currDay = Enums.eWeekdays.sunday;
        tomorrow = Enums.eWeekdays.monday;
        break;
      case 1:
        currDay = Enums.eWeekdays.monday;
        tomorrow = Enums.eWeekdays.tuesday;
        break;
      case 2:
        currDay = Enums.eWeekdays.tuesday;
        tomorrow = Enums.eWeekdays.wednesday;
        break;
      case 3:
        currDay = Enums.eWeekdays.wednesday;
        tomorrow = Enums.eWeekdays.thursday;
        break;
      case 4:
        currDay = Enums.eWeekdays.thursday;
        tomorrow = Enums.eWeekdays.friday;
        break;
      case 5:
        currDay = Enums.eWeekdays.friday;
        tomorrow = Enums.eWeekdays.saturday;
        break;
      case 6:
        currDay = Enums.eWeekdays.saturday;
        tomorrow = Enums.eWeekdays.sunday;
        break;
    }

    let isBeforeEndOfDayForCurrentSlot = true;
    if (el.timeOfDayEnd) {
      // If current time of day is after end of day time.
      if (minutesPassedToday > militaryToMinutes(el.timeOfDayEnd)) {
        isBeforeEndOfDayForCurrentSlot = false;
      }
    }

    // If days of week are specified in this timeslot but the current day of the week is not included in that collection then return false
    const currentDayInCurrTimeslotAndItsNotEndOfDayYet = el.daysOfWeek.includes(currDay) && isBeforeEndOfDayForCurrentSlot;
    if (el.daysOfWeek && el.daysOfWeek.length && !currentDayInCurrTimeslotAndItsNotEndOfDayYet && !el.daysOfWeek.includes(tomorrow)) {
      return false;
    }

    return true;
  });
};

export const getAvailibilitiesForLocation = (location: EstablishmentLocation) => {

  const tablesideAvailableRightNow = location.isTablesideOn && isRightTime(location.tablesideTimeSlots, location.utcOffset);
  const takeoutAvailableRightNow = location.isTakeoutOn && isRightTime(location.takeoutTimeSlots, location.utcOffset);
  const deliveryAvailableRightNow = location.isDeliveryOn && isRightTime(location.deliveryTimeSlots, location.utcOffset);
  const canOrderTakeoutForNowOrLater = takeoutAvailableRightNow || (location.orderAheadEnabled && location.isTakeoutOn && orderAheadForPossibleForTimeslots(location.takeoutTimeSlots, location.utcOffset));
  const canOrderDeliveryForNowOrLater = deliveryAvailableRightNow || (location.orderAheadEnabled && location.isDeliveryOn && orderAheadForPossibleForTimeslots(location.deliveryTimeSlots, location.utcOffset));
  const canOrderTakeoutOrDeliveryForNowOrLater = canOrderTakeoutForNowOrLater || canOrderDeliveryForNowOrLater;

  return {
    tablesideAvailable: tablesideAvailableRightNow,
    takeoutAvailable: takeoutAvailableRightNow,
    deliveryAvailable: deliveryAvailableRightNow,
    canOrderTakeoutForNowOrLater, // For right now or a future time.
    canOrderDeliveryForNowOrLater, // For right now or a future time.
    cannotOrderTakeoutOrDelivery: !canOrderTakeoutOrDeliveryForNowOrLater,
  };
};

export const getResourceArrayWithValidTimeslotsAndVisible = (array: any[]): ResourceObj[] => {
  return array.filter((el: any) => {
    return isRightTime(el.timeSlots, store.state.currentLocation.utcOffset) && el.isVisible;
  });
};

// Given a string am/pm time, converts it into minutes since the beginning of the day.
export const militaryToMinutes = (date: string) => {
  const timeStringArray = date.split(':');
  const hours: number = Number(timeStringArray[0]);
  const minutes: number = Number(timeStringArray[1]);
  return minutes + hours * 60;
};

// Runs the passed in function once the time in ms has completed, but resets the timer if delay is called again.
export const delay = (func: () => void, ms: number) => {
  const doc: any = (document as any);
  (() => {
    if (doc.genericDelayTimer) {
      clearTimeout(doc.genericDelayTimer);
    }
    doc.genericDelayTimer = setTimeout(func, ms);
  })();
};

export const getPostTaxAmountForGenericCharge = (basePrice: number) => {

  const province = store.state.currentLocation.address.administrativeAreaLevel1;
  let taxRate = NaN;

  switch (province) {
    case 'ON': {
      taxRate = 1.13; // 13% HST (point of sale rebate of 8% on prepared meals $4.00 and under)
      break;
    }
    case 'BC': {
      taxRate = 1.05; // GST
      break;
    }
    case 'PE':
      taxRate = 1.14; // HST
    case 'SK':
      taxRate = 1.11; // 6% Retail Sales Tax + 5% GST
      break;
    case 'QC':
      taxRate = 1.14975; // 9.975% Quebec Sales Tax + 5% GST
      break;
    case 'AB':
    case 'NU':
    case 'YT':
    case 'NT':
      taxRate = 1.05; // GST
      break;
    case 'MB':
      taxRate = 1.13; // 8% Retail Sales Tax + 5% GST
      break;
    case 'NS':
    case 'NL':
    case 'NB':
      taxRate = 1.15; // HST.
      break;
  }

  return basePrice * taxRate; // This will probably get more complicated later so it's not a constant.
};

export const getTaxRateFor = (menuItem: MenuItem): number => {

  // https://www.restaurantscanada.org/industry-news/sales-taxes-on-food-beverages/

  const province = store.state.currentLocation.address.administrativeAreaLevel1;

  switch (province) {
    case 'ON': {
      const meals = 1.13; // 13% HST (point of sale rebate of 8% on prepared meals $4.00 and under)
      const mealsUnderFourDollars = 1.05; // 13% HST + -8% rebate.
      const alcoholicBeverage = 1.13; // 13% HST
      const nonAlcoholicBeverage = 1.13; // 13% HST (8% point of sale rebate applies if purchased with a meal $4.00 and under)

      // TODO. Package beverage with $4 meal discount.
      let salesTaxRate = menuItem.price > 400 ? meals : mealsUnderFourDollars;
      if (menuItem.isBeverage) {
        salesTaxRate = nonAlcoholicBeverage;
        if (menuItem.isAlcoholic) {
          salesTaxRate = alcoholicBeverage;
        }
      }
      return salesTaxRate;
    }
    case 'BC': {
      const meals = 1.05; // GST
      const alcoholicBeverage = 1.15; // 10% PST + 5% GST
      const nonAlcoholicBeverage = 1.05; // GST

      // TODO. Package beverage with $4 meal discount.
      let salesTaxRate = meals;
      if (menuItem.isBeverage) {
        salesTaxRate = nonAlcoholicBeverage;
        if (menuItem.isAlcoholic) {
          salesTaxRate = alcoholicBeverage;
        }
      }
      return salesTaxRate;
    }
    case 'PE':
      return 1.14; // HST
    case 'SK': {
      const meals = 1.11; // 6% Retail Sales Tax + 5% GST
      const alcoholicBeverage = 1.15; // 10% PST + 5% GST
      const nonAlcoholicBeverage = 1.11; // 6% PST + 5% GST

      // TODO. Package beverage with $4 meal discount.
      let salesTaxRate = meals;
      if (menuItem.isBeverage) {
        salesTaxRate = nonAlcoholicBeverage;
        if (menuItem.isAlcoholic) {
          salesTaxRate = alcoholicBeverage;
        }
        return salesTaxRate;
      }
    }
    case 'QC':
      return 1.09975 + 1.05; // Quebeck sales tex + GST.
    case 'AB':
    case 'NU':
    case 'YT':
    case 'NT':
      return 1.05; // GST
    case 'MB':
      return 1.13; // 8% Retail Sales Tax + 5% GST
    case 'NS':
    case 'NL':
    case 'NB':
      return 1.15; // HST.
    default:
      return NaN;
  }
};

export const formatCurrencyForMenuItem = (menuItem: MenuItem): string => {
  return formatCurrencyHelper(menuItem.price, false, true, menuItem);
};

export const formatCurrency = (price: number | null, showSign: boolean = false, addHtml: boolean = true): string => {
  return formatCurrencyHelper(price, showSign, addHtml, null);
};

const formatCurrencyHelper = (price: number | null, showSign: boolean = false, addHtml: boolean = true, menuItem: MenuItem | null = null): string => {

  if (!price) {
    return t.free;
  }

  // https://www.restaurantscanada.org/industry-news/sales-taxes-on-food-beverages/
  if (menuItem) {
    const salesTaxRate = getTaxRateFor(menuItem);
    if (store.state.includeTaxWithPrices && salesTaxRate) { // Include taxes
      price *= salesTaxRate;
    }
  }

  // Convery from int to float now that the accounting is done.
  price = price / Constants.CENTS_DOLLARS_MULTIPLIER;

  const arr: string[] = Number(Math.abs(price)).toFixed(2).split('.');
  let dollars: string;
  let cents: string;
  let ret: string = '';
  if (showSign) {
    ret += addHtml ? `<span class="price-sign">${price > 0 ? '+' : '-'}</span>` : price > 0 ? '+' : '-';
  }
  ret += addHtml ? `<span class="money-symbol">${store.state.moneySymbol}</span>` : store.state.moneySymbol;
  switch (store.state.priceDisplayFormat) {
    case Enums.ePriceDisplayFormats.minDecimal:
      dollars = arr[0];
      cents = arr[1];
      ret += addHtml ? `<span>${dollars}</span>` : dollars;
      if (cents !== '00') {
        ret += addHtml ? `<span class="small-price">.${cents}</span>` : '.' + cents;
      }
      break;
    case Enums.ePriceDisplayFormats.twoDecimal:
      dollars = arr[0];
      cents = arr[1];
      ret += addHtml ? `<span>${dollars}</span><span class="small-price">.${cents}</span>` : `${dollars}.${cents}`;
      break;
  }
  return ret;
};

const TIME_STAMP_SUFFIX = '_timeStamp';
const LOCATION_ID_SUFFIX = '_locationId';

export const localStoreSetSimple = (fieldName: string, storageString: string) => {
  storage.setItem(fieldName, storageString);
};

export const localStoreGetSimple = (fieldName: string) => {
  return storage.getItem(fieldName);
};

export const localStoreSet = (fieldName: string, storageString: string) => {
  storage.setItem(fieldName, storageString);
  storage.setItem(fieldName + TIME_STAMP_SUFFIX, Date.now().toString());
  storage.setItem(fieldName + LOCATION_ID_SUFFIX, store.state.locationId.toString());
};

export const localStoreGet = (fieldName: string, ignoreLocationIdReq: boolean = false) => {
  const msInAnHour = 3600000;
  const timeStamp = storage.getItem(fieldName + TIME_STAMP_SUFFIX) || '0';
  const locationId = storage.getItem(fieldName + LOCATION_ID_SUFFIX) || '-1';
  // If less than 5 hours and at same location then get the data.
  if (Date.now() - parseInt(timeStamp, 10) < msInAnHour * 5 && (ignoreLocationIdReq || parseInt(locationId, 10) === store.state.locationId)) {
    return storage.getItem(fieldName);
  }
  // Otherwise, expire it and return null.
  localStoreRemove(fieldName);
  return null;
};

export const localStoreRemove = (fieldName: string) => {
  storage.removeItem(fieldName);
  storage.removeItem(fieldName + TIME_STAMP_SUFFIX);
  storage.removeItem(fieldName + LOCATION_ID_SUFFIX);
};

export const setToBeSentOrders = (orderItems: OrderItem[]) => {

  aggregateOrders(orderItems);

  if (!orderItems.length) {
    // Copy last pending order for re-order.
    const newLastSentOrders = store.state.toBeSentOrders?.length ? store.state.toBeSentOrders : store.state.lastSentOrders; // The new last sent orders should be the orders being sent, or it no orders, then just use the current value.
    localStoreSet('lastSentOrders', JSON.stringify(newLastSentOrders));
    store.commit('setlastSentOrders', newLastSentOrders);
  }
  localStoreSet('toBeSentOrders', JSON.stringify(orderItems));
  store.commit('setToBeSentOrders', orderItems);
};

// Desctructive quantity aggregator. Takes identical items and deletes all but one with the aggregated quantity. Only use this on order lists that haven't made it to the backend yet. Otherwise it'll delete valid notificationIds that are linked to live notifications.
export const aggregateOrders = (orderItems: OrderItem[]) => {
  orderItems.forEach((baseOrder, baseIndex) => {
    if (((baseOrder as any).markedForRemoval)) { // If true then this was already compared against the actual base order.
      return;
    }
    const flatSelectedOptionsForFirst = baseOrder.selectedOptions ? JSON.stringify(baseOrder.selectedOptions) : '';
    orderItems.forEach((comparedOrder, comparedIndex) => {
      const flatSelectedOptionsForCompared = comparedOrder.selectedOptions ? JSON.stringify(comparedOrder.selectedOptions) : '';
      if (baseOrder.menuItemDocId === comparedOrder.menuItemDocId && // If the same menu item.
        flatSelectedOptionsForFirst === flatSelectedOptionsForCompared && // If the same selected options.
        baseOrder.specialRequest === comparedOrder.specialRequest && // If the same special request.
        baseIndex !== comparedIndex) { // If not literally the exact same item in the array.
        baseOrder.quantity += comparedOrder.quantity;
        baseOrder.totalPrice += comparedOrder.totalPrice;
        baseOrder.totalPriceWithTax += comparedOrder.totalPriceWithTax;
        (comparedOrder as any).markedForRemoval = true;
      }
    });
  });
  const filteredArray = orderItems.filter((oi: any) => !oi.markedForRemoval);
  orderItems.length = 0;
  filteredArray.forEach((oi: OrderItem) => { // Can't set orders directly if I want to make this a desctructive method since doing "orders = something" would make the orders parameter pass by value instead of pass by reference.
    orderItems.push(oi);
  });
};

export const getOrderingFromString = (): string => {
  const supplantArray = [store.state.currentEstablishment.name, store.state.stationCode, store.state.currentLocation.formattedAddress];
  let orderString = '';
  switch (store.state.appMode) {
    case Enums.eAppModes.tableside:
      orderString = t.youAreOrderingFromTableside;
      break;
    case Enums.eAppModes.takeout:
      orderString = t.youAreOrderingFromTakeout;
      break;
    case Enums.eAppModes.delivery:
      orderString = t.youAreOrderingFromDelivery;
      break;
    case Enums.eAppModes.viewOnly:
      orderString = t.youAreViewing;
      break;
  }
  return orderString ? orderString.supplant(supplantArray) : '';
};

export const getDrinkingAge = (): number => {
  const province = store.state.currentLocation.address.administrativeAreaLevel1;
  switch (province) {
    case 'ON':
    case 'QC':
    case 'NS':
    case 'NB':
    case 'BC':
    case 'PE':
    case 'SK':
    case 'NL':
    case 'NU':
    case 'YT':
    case 'NT':
      return 19;
    case 'QC':
    case 'AB':
    case 'MB':
      return 18;
  }
  return 19;
};

export const enumKeyNumValue = (key: string | null, enumObj: any) => {
  let ret = 0;
  if (key) {
    Object.keys(enumObj).forEach((str: string, index: number) => {
      if (str === key) {
        ret = index;
      }
    });
  }
  return ret;
};

export const createFoodValueProperties = (defaultVal: any) => {
  const ret: any = {};
  Constants.FOOD_VALUES.forEach((f: string) => {
    ret[f] = defaultVal;
  });
  return ret;
};

export const updateBannedUsers = () => {
  store.state.currentSubscriptionDoc.collection('subscriptionMetadata').doc('bannedUsers').get().then((bannedUsersDocSnap) => {
    if (bannedUsersDocSnap.exists) {
      const updatedBannedUsersArray = (bannedUsersDocSnap as any).data().bannedUsers;
      store.commit('setBannedUsers', updatedBannedUsersArray);
      if (updatedBannedUsersArray.includes(store.state.userId)) {
        showGlobalModal(t.banned, t.youHaveBeenBanned.supplant([store.state.userId]));
        hideLoading();
      }
    }
  });
};

export const timeSlotsToString = (timeSlots: TimeSlot[]) => {
  let ret: string = '';

  function daysOfTheWeekToString(daysOfTheWeek: string[]) {
    return daysOfTheWeek.map((day: string) => {
      return t[day];
    }).join(', ');
  }

  timeSlots.forEach((timeSlot) => {
    const startTime = dateFnsFormat(dateFnsParse(timeSlot.timeOfDayStart, 'H:mm', new Date()), 'h:mm a');
    const endTime = dateFnsFormat(dateFnsParse(timeSlot.timeOfDayEnd, 'H:mm', new Date()), 'h:mm a');
    ret += `<div class="time-slot">${startTime} - ${endTime}${timeSlot.daysOfWeek.length ? ` <small>on ${daysOfTheWeekToString(timeSlot.daysOfWeek)}.</small>` : ` <small>${t.everyDay}</small>`}</div>`;
  });
  return ret;
};

export const showMenuSelection = () => {
  if (store.state.menuSelectionPossible) {
    routerPush({ path: Constants.allRoutes.menuSelection });
  }
};

export const routerPush = ({ path }: { path: string }) => {
  const permalinkId = store.state.permalinkId || '';
  const newPath = permalinkId ? `/${permalinkId}${path}` : `${path}`;
  if (newPath !== location.pathname) {
    router.push({
      path: newPath,
    });
  }
};

export const getDistanceBetweenPoints = ([userLat, userLon]: [number, number], [lat2, lon2]: [number, number]): number => {

  let distanceInKm: number = 1000;
  // https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - userLat);  // deg2rad below
  const dLon = deg2rad(lon2 - userLon);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(userLat)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
  const d = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  distanceInKm = R * d; // Distance in km

  function deg2rad(deg: number) {
    return deg * (Math.PI / 180);
  }
  return Math.round(distanceInKm * 100) / 100;
};

export const getDistance = (userLat: number | null, userLon: number | null) => {

  if (userLat === null || userLon === null) {
    return null;
  }

  const lat2 = store.state.currentLocation.latitude as number;
  const lon2 = store.state.currentLocation.longitude as number;
  let distanceInKm: number = 1000;
  // https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - userLat);  // deg2rad below
  const dLon = deg2rad(lon2 - userLon);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(userLat)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
  const d = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  distanceInKm = R * d; // Distance in km

  function deg2rad(deg: number) {
    return deg * (Math.PI / 180);
  }
  return Math.round(distanceInKm * 100) / 100;
};

export const getUserLocation = (locationReason: string): Promise<{ latitude: number; longitude: number } | null> => {
  return new Promise((resolve: any, reject: any) => {
    if ('geolocation' in navigator) {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {

        function requestLocation() {
          showLoading();
          navigator.geolocation.getCurrentPosition((position) => {
            hideLoading();
            resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude });
          }, (error) => { // Permission denied.
            hideLoading();
            reject(null);
          });
        }
        switch (result.state) {
          case 'granted':
            requestLocation();
            break;
          case 'prompt':
            showConfirmation(t.requestingLocationModalTitle, locationReason, () => {
              requestLocation();
            });
            break;
          case 'denied':
            reject(null);
            break;
        }
      });
    } else {
      reject(null);
    }
  });
};

export const anonymousSignIn = () => {
  eventBus.$emit('closeModals');
  showConfirmation(t.guestCheckout, t.guestCheckoutInfo, () => {
    showLoading();
    firebase.auth().signInAnonymously().then(() => {
      showNotice('Signed in as guest.');
    }).catch((error) => {
      showError('Anonymous sign in failed. Try disabling private browsing if it is currently enabled. ' + error?.message);
    }).finally(() => {
      hideLoading();
    });
  }, () => {
    rootComponent.showSignInFunc(t.accountRequired, false);
  });
};

export const sendNotificationToEstablishment = (requestNotification: TMNotification, userEstablishmentExchangeDocUpdate: UserEstablishmentExchangeObjectUpdate = {}, clearToBeSetOrders: boolean = false) => {

  if (rootComponent.isTestingMode) {
    showNotice(t.cannotDoThisInTestingMode);
    return;
  }

  showLoading();

  // Can only send notifications when logged in.
  if (store.state.isLoggedIn) {
    sendNotification();
  } else {
    firebase.auth().signInAnonymously().then(() => {
      afterSignInCallBack = sendNotification;
    }).catch((error) => {
      hideLoading();
      showError('Anonymous sign in failed. Try disabling private browsing if it is currently enabled. ' + error?.message);
    });
  }

  async function sendNotification() {

    if (store.state.bannedUsers.includes(store.state.userId)) {
      updateBannedUsers();
      return;
    }

    if (store.state.appMode === Enums.eAppModes.tableside) {
      const coods = await getUserLocation(t.requestingLocationForTablesideOrdering);
      if (coods) {
        requestNotification.distanceFromRequester = getDistance(coods.latitude, coods.longitude);
      } else {
        requestNotification.distanceFromRequester = null;
      }
    } else {
      requestNotification.distanceFromRequester = null;
    }

    requestNotification.dateCreated = Date.now();

    // If this is the first notification being sent to an establishment we'll use an empty user establishment exchange object.
    const oldUserEstablishmentExchangeObject: UserEstablishmentExchangeObject = store.state.currentUserEstablishmentExchangeObject;
    const newNotificationsToTheEstablishment = oldUserEstablishmentExchangeObject.notificationsToTheEstablishment || [];

    newNotificationsToTheEstablishment.push({
      ...requestNotification,
    });

    const update: UserEstablishmentExchangeObjectUpdate = {
      notificationsToTheEstablishment: newNotificationsToTheEstablishment,
      dateUpdated: firebase.firestore.FieldValue.serverTimestamp(),
      ...userEstablishmentExchangeDocUpdate,
      stationId: store.state.stationId,
      pushNotificationMessage: {
        destination: Enums.ePushDesinations.establishment,
        title: t.newNotification.supplant([t[requestNotification.type], store.state.stationId]),
      },
    };

    if ((requestNotification as CancellationRequestNotification).cancellationRequestOrderItemId) {
      update.tablesideOrderCollection = oldUserEstablishmentExchangeObject.tablesideOrderCollection;
      Object.values(update.tablesideOrderCollection).forEach((GenericOrderObject: GenericOrderObject) => {
        GenericOrderObject.orderItems.map((oi: OrderItem) => {
          if (oi.orderItemId === (requestNotification as CancellationRequestNotification).cancellationRequestOrderItemId) {
            return {
              ...oi,
              cancelRequestPending: true,
            };
          }
          return oi;
        });
      });
    }

    ExchangeFuncs.updateExchangeObject(update, t.messageSent.supplant([t[requestNotification.type]]), clearToBeSetOrders);
  }
};

export const deepCopy = (object: any) => {
  return JSON.parse(JSON.stringify(object));
};

export const updateExchangeObject = ExchangeFuncs.updateExchangeObject;

export const isEmptyObject = (obj: any): boolean => {
  return obj && Object.entries(obj).length === 0 && obj.constructor === Object;
};

export const nonDebugLog = (...args: any) => {
  console.log(...args);
};

// Sometimes storing nulls, false values, and empty objects for some objects in firebase harms readability and it always increases storage costs. Use this function when you feel like it might help database readability.
export const removeFalsyExceptZero = (obj: any) => {
  const newObj: any = {};
  for (const [key, val] of Object.entries(obj)) {
    if ((val && !isEmptyObject(val)) || val === 0) {
      newObj[key] = val;
    }
  }
  return newObj;
};

export const generateId = () => {
  return currFirestore.collection('This is just to generate IDs').doc().id;
};

export const standardApiFetch = (endpoint: string, body: any, callback: (jsonResponse: any) => void = (): void => undefined) => {
  showLoading();
  let apiPrefix: string = '';
  if (!isProductionEnv()) {
    apiPrefix = 'test-';
  }
  return fetch(`https://api.nickfish.net/api/${apiPrefix}${endpoint}`, {
    method: 'post',
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    headers: {
      'Content-Type': 'application/json',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *client
    body: JSON.stringify(body),
  }).then((response) => {
    response.json().then(callback).catch((error: any) => {
      showError('Error getting json from the response. ' + error?.message);
    });
  }).catch((error: any) => {
    showError('Error making fetch call. ' + error?.message);
  }).finally(() => {
    hideLoading();
  });
};

export const getTotalForOrderItems = (orderItems: OrderItem[], type: 'postTax' | 'preTax') => {
  return orderItems.reduce((accumulator, orderItem: OrderItem) => {
    return accumulator + (type === 'preTax' ? orderItem.totalPrice : orderItem.totalPriceWithTax);
  }, 0);
};

export const initTheme = (establishment: Establishment) => {

  store.commit('setThemeWasInitialized', true);

  function getThemeColor(param: string): number[] | null {
    const str = getParameterByName(param);
    if (str) { return str.split(',').map((col) => parseInt(col, 10)); }
    return null;
  }

  // Prioritize customization params as follow: 1) Query string params. 2) User settings (TODO). 3) Restuarant settings in DB. 4) Defaults for missing values.
  const primaryColor: number[] = getThemeColor('pc') || establishment.primaryColor || [50, 50, 60, 1];
  const accentColor: number[] = getThemeColor('ac') || establishment.accentColor || [90, 90, 130, 1];
  const fontColorOnPrimary: number[] = getThemeColor('fcp') || establishment.fontColorOnPrimary || [255, 255, 255, 1];
  const fontColorOnAccent: number[] = getThemeColor('fca') || establishment.fontColorOnAccent || [255, 255, 255, 1];
  const primaryFontName: string = getParameterByName('pfnt') || establishment.primaryFont || 'Roboto';
  const secondaryFontName: string = getParameterByName('sfnt') || establishment.secondaryFont || 'Oswald';
  const primaryFontVariant: string = getParameterByName('pfntv') || establishment.primaryFontVariant || 'regular';
  const secondaryFontVariant: string = getParameterByName('sfntv') || establishment.secondaryFontVariant || 'regular';
  const primaryFontScale: number = parseFloat(getParameterByName('pfnts')) || establishment.primaryFontScale || 1;
  const secondaryFontScale: number = parseFloat(getParameterByName('sfnts')) || establishment.secondaryFontScale || 1;
  let secondaryFontUppercase: boolean = Boolean(establishment.secondaryFontUppercase);
  let primaryFontWeight: string = 'normal';
  let secondaryFontWeight: string = 'normal';

  if (getParameterByName('sfntu') !== '') {
    secondaryFontUppercase = Boolean(getParameterByName('sfntu') === 'true');
  }

  let priceDisplayFormat: string;
  if (Boolean(getParameterByName('pdf'))) {
    priceDisplayFormat = getParameterByName('pdf');
  } else if (establishment.priceDisplayFormat !== undefined) {
    priceDisplayFormat = establishment.priceDisplayFormat;
  } else {
    priceDisplayFormat = Enums.ePriceDisplayFormats.minDecimal;
  }
  store.commit('setPriceDisplayFormat', priceDisplayFormat);

  const linkEl: any = document.createElement('link');
  linkEl.type = 'text/css';
  linkEl.rel = 'stylesheet';

  let primaryTextInsertion = primaryFontName;
  if (primaryFontVariant !== 'regular') {
    if (primaryFontVariant === 'bold') {
      primaryFontWeight = 'bold';
    } else {
      primaryTextInsertion += `:${primaryFontVariant}`;
    }
  }
  let secondaryTextInsertion = secondaryFontName;
  if (secondaryFontVariant !== 'regular') {
    if (secondaryFontVariant === 'bold') {
      secondaryFontWeight = 'bold';
    } else {
      secondaryTextInsertion += `:${secondaryFontVariant}`;
    }
  }

  primaryTextInsertion = primaryTextInsertion.replace('italic', 'i');
  secondaryTextInsertion = secondaryTextInsertion.replace('italic', 'i');

  if (primaryTextInsertion === secondaryTextInsertion) {
    linkEl.href = `https://fonts.googleapis.com/css?family=${primaryTextInsertion}`;
  } else {
    linkEl.href = `https://fonts.googleapis.com/css?family=${primaryTextInsertion}|${secondaryTextInsertion}`;
  }

  // Setting a theme color for Chrome.
  const metaEl: any = document.createElement('meta');
  metaEl.name = 'theme-color';
  metaEl.content = arrayToHex(primaryColor);

  function arrayToRGBA(arr: number[]) {
    return `rgba(${arr[0]}, ${arr[1]}, ${arr[2]}, ${typeof arr[3] === 'number' ? arr[3] : 1})`;
  }

  function arrayToHex(arr: number[]) {
    return `#${arr[0].toString(16)}${arr[1].toString(16)}${arr[2].toString(16)}`;
  }

  function getLuminance(colorArray: number[]): number {
    const newColorArray: number[] = [];
    colorArray.forEach((color: number, index: number) => {
      color = color / 255;
      if (color <= 0.03928) {
        newColorArray[index] = color / 12.92;
      } else {
        newColorArray[index] = Math.pow(((color + 0.055) / 1.055), 2.4);
      }
    });
    const lum: number = (0.2126 * newColorArray[0] + 0.7152 * newColorArray[1] + 0.0722 * newColorArray[2]);
    return lum;
  }

  function rgbToHsv([red, green, blue]: [number, number, number]) {
    let rr: number = 0;
    let gg: number = 0;
    let bb: number = 0;
    let h: number = 0;
    let s: number = 0;
    const r: number = red / 255;
    const g: number = green / 255;
    const b: number = blue / 255;
    const v: number = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = (col: number) => {
      return (v - col) / 6 / diff + 1 / 2;
    };
    if (diff === 0) {
      h = s = 0;
    } else {
      s = diff / v;
      rr = diffc(r);
      gg = diffc(g);
      bb = diffc(b);
      if (r === v) {
        h = bb - gg;
      } else if (g === v) {
        h = 1 / 3 + rr - bb;
      } else if (b === v) {
        h = 2 / 3 + gg - rr;
      }
      if (h < 0) {
        h += 1;
      } else if (h > 1) {
        h -= 1;
      }
    }
    return {
      h: Math.round(h * 360),
      s,
      v,
    };
  }

  function areSimilarColors(col1: number[], col2: number[]): boolean {
    let totalDifference = 0;
    col1.forEach((rgbVal: number, index: number) => {
      totalDifference += Math.abs(col1[index] - col2[index]);
    });
    return totalDifference < 150;
  }

  function isNearBlack(col: number[]): boolean {
    for (const val of col) {
      if (val > 60) {
        return false;
      }
    }
    return true;
  }

  const primaryHsv: any = rgbToHsv(primaryColor as any);
  const primaryLuminance: number = Math.max(getLuminance(primaryColor), 0.1);
  const primaryColorSaturation: number = Math.max(primaryHsv.s, 0.1);
  const primaryColorIsHighLuminance: boolean = primaryLuminance > 0.179;
  const primaryColorIsHighSaturation: boolean = primaryColorSaturation > 0.5;

  const fontColorOnPrimaryRGBA = arrayToRGBA(fontColorOnPrimary);
  const fontColorOnAccentRGBA = arrayToRGBA(fontColorOnAccent);
  const primaryColorRGBA = arrayToRGBA(primaryColor);
  const primaryHeavyBorderRGBA = arrayToRGBA([...fontColorOnPrimary, 0.45]);
  const primaryLightBorderRGBA = arrayToRGBA([...fontColorOnPrimary, 0.25]);
  const primaryVeryLightBorderRGBA = arrayToRGBA([...fontColorOnPrimary, 0.1]);
  const complimentStrength: number = primaryColorIsHighSaturation ?
    0.2 * primaryColorSaturation + 0.5 * primaryLuminance
    :
    0.5 * primaryColorSaturation + 0.5 * primaryLuminance;
  const primaryComplimentRGBA: string = arrayToRGBA([255, 255, 255, complimentStrength]);
  const primaryComplimentLightRGBA: string = arrayToRGBA([255, 255, 255, complimentStrength * 0.35]);
  const primaryComplimentHarshRGBA: string = arrayToRGBA([255, 255, 255, complimentStrength * 1.75]);
  const accentColorRGBA = arrayToRGBA(accentColor);
  const accentColorFadedRGBA = arrayToRGBA([...accentColor, 0.25]);
  const accentLightBorderRGBA = arrayToRGBA([...fontColorOnAccent, 0.25]);
  const accentFadedBorderRGBA = arrayToRGBA([...accentColor, 0.5]);

  const docEl = document.documentElement as HTMLElement;
  const docHead = document.head as HTMLElement;

  docEl.style.setProperty('--font-color-on-primary', fontColorOnPrimaryRGBA);
  docEl.style.setProperty('--font-color-on-accent', fontColorOnAccentRGBA);
  docEl.style.setProperty('--primary-color', primaryColorRGBA);
  docEl.style.setProperty('--primary-heavy-border-color', primaryHeavyBorderRGBA);
  docEl.style.setProperty('--primary-compliment', primaryComplimentRGBA);
  docEl.style.setProperty('--primary-compliment-light', primaryComplimentLightRGBA);
  docEl.style.setProperty('--primary-compliment-harsh', primaryComplimentHarshRGBA);
  docEl.style.setProperty('--accent-color', accentColorRGBA);
  docEl.style.setProperty('--accent-color-faded', accentColorFadedRGBA);
  docEl.style.setProperty('--accent-light-border-color', accentLightBorderRGBA);
  docEl.style.setProperty('--accent-fade-border-color', accentFadedBorderRGBA);
  docEl.style.setProperty('--primary-font-name', primaryFontName);
  docEl.style.setProperty('--secondary-font-name', secondaryFontName);
  docEl.style.setProperty('--primary-font-weight', primaryFontWeight);
  docEl.style.setProperty('--secondary-font-weight', secondaryFontWeight);
  docEl.style.setProperty('--primary-font-scale', primaryFontScale.toString()) ;
  docEl.style.setProperty('--secondary-font-scale', secondaryFontScale.toString());
  docEl.style.setProperty('--uppercase-secondary-font', secondaryFontUppercase ? 'uppercase' : 'initial');

  store.commit('setStripeStyles', {
    fontColorOnPrimaryRGBA,
    primaryFontName,
  });

  if (primaryColorIsHighLuminance) {
    docEl.classList.remove('primary-color-is-low-luminance');
    docEl.classList.add('primary-color-is-high-luminance');
  } else {
    docEl.classList.remove('primary-color-is-high-luminance');
    docEl.classList.add('primary-color-is-low-luminance');
  }

  if (areSimilarColors(primaryColor, accentColor)) {
    docEl.classList.add('primary-and-accent-are-similar');
  } else {
    docEl.classList.remove('primary-and-accent-are-similar');
  }

  if (isNearBlack(accentColor)) {
    docEl.classList.add('accent-is-near-black');
  } else {
    docEl.classList.remove('accent-is-near-black');
  }

  if (isNearBlack(primaryColor)) {
    store.commit('setIsDarkTheme', true);
    docEl.style.setProperty('--primary-light-border-color', primaryVeryLightBorderRGBA);
    docEl.classList.add('primary-is-near-black');
  } else {
    docEl.style.setProperty('--primary-light-border-color', primaryLightBorderRGBA);
    docEl.classList.remove('primary-is-near-black');
  }

  docHead.appendChild(linkEl);
  docHead.appendChild(metaEl);
};
